import { render } from "./PortalScopePill.vue?vue&type=template&id=94eb19e8&scoped=true"
import script from "./PortalScopePill.vue?vue&type=script&lang=js"
export * from "./PortalScopePill.vue?vue&type=script&lang=js"

import "./PortalScopePill.vue?vue&type=style&index=0&id=94eb19e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94eb19e8"]])

export default __exports__